import React from "react";
import LegalPage from "../Legal/LegalPage";

const sections = [
  {
    title: "Refunds",
    paragraphs: ["All sales are final. Refunds will not be issued."],
  },
  {
    title: "Contact information",
    paragraphs: [
      "Questions about this policy should be sent to sj135637@gmail.com.",
    ],
  },
];

const RefundPolicy = () => (
  <LegalPage
    eyebrow="Payments"
    title="Online Refund Policy"
    sections={sections}
  />
);

export default RefundPolicy;
